import { queryClient } from '@/lib/queryClient';
import { useAuthStore } from '@/store/authStore';

/**
 * 세션 종료 — 토큰·직원 정보와 **조회 캐시를 함께** 비운다.
 *
 * 토큰만 지우면 React Query 캐시가 메모리에 그대로 남는다. 새로고침 없이 다른
 * 계정으로 다시 로그인하면 이전 계정의 응답이 그대로 화면에 뜬다. 전역
 * staleTime이 60초라 그동안은 재조회도 하지 않아서, 실제로 대시보드 '세션 정보'에
 * 직전 로그인 계정이 남아 보였다. 입소자 목록·메모처럼 권한이 다르면 보이지
 * 말아야 할 데이터도 같은 이유로 남는다.
 *
 * 로그아웃 버튼, 토큰 갱신 실패(자동 로그아웃), 새 로그인 직전 — 세 곳 모두 여기를 쓴다.
 */
export function clearSession(): void {
  useAuthStore.getState().clear();
  queryClient.clear();
}
